import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useImmer } from "use-immer";

import { Dialog } from "@mui/material";
import { CancelContent } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/CancelContent";
import { CancelForm } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/Forms/CancelForm/CancelForm";
import { PauseContent } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/PauseContent";
import { Action } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/types";
import { getDialog, setDialog } from "@src/store/slices/global";

import { PauseForm } from "./Forms/PauseForm/PauseForm";

export const ManageSubscriptionsDialog = () => {
  const [action, setAction] = useImmer<Action>("cancelForm");
  const dispatch = useDispatch();
  const dialog = useSelector(getDialog("manageSubscriptions"));

  const handleClose = () => {
    dispatch(
      setDialog({
        dialog: "manageSubscriptions",
        open: false,
        props: {
          stripeSubscriptionLinkId: null,
          action: "pause",
        },
      })
    );
  };

  useEffect(() => {
    if (dialog.isOpen) {
      setAction(dialog.props?.action as Action);
    }
  }, [dialog.isOpen]);

  if (!dialog.isOpen || !dialog.props?.stripeSubscriptionLinkId) {
    return null;
  }

  const Content =
    action === "cancel"
      ? CancelContent
      : action === "pauseForm"
        ? PauseForm
        : action === "cancelForm"
          ? CancelForm
          : PauseContent;

  return (
    <Dialog
      open={dialog.isOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "15px",
          padding: "30px 40px 30px 40px",
          maxHeight: "90vh",
        },
      }}
    >
      <Content
        setAction={setAction}
        handleClose={handleClose}
        stripeSubscriptionLinkId={dialog.props.stripeSubscriptionLinkId}
      />
    </Dialog>
  );
};
